<h2 mat-dialog-title class="text-center">
    <span class="text-white">{{ isEditMode ? 'Editar Bus' : 'Crear Nuevo Bus' }}</span>
    <button matIconButton (click)="onCancel()" class="dialog-close top-0 right-0">
        <mat-icon>close</mat-icon>
    </button>
</h2>
<mat-dialog-content>
    <form [formGroup]="busForm" (ngSubmit)="onSubmit()">
        <mat-form-field floatLabel="always" class="w-full mb-4 border-0">
            <mat-label class="text-gray text-lg">Número de Bus (Name)</mat-label>
            <input matInput formControlName="name" placeholder="Ej: 175" class="text-lg text-white bg-blue-primary">
            <mat-error *ngIf="nameControl?.invalid && (nameControl?.dirty || nameControl?.touched)">
                <span *ngIf="nameControl?.errors?.['required']">El número de bus es requerido.</span>
            </mat-error>
        </mat-form-field>
        <mat-form-field floatLabel="always" class="w-full mb-4 border-0">
            <mat-label class="text-gray text-lg">Placas</mat-label>
            <input matInput formControlName="licensePlate" placeholder="Ej: P-123ABC" class="text-lg text-white bg-blue-primary">
            <mat-error *ngIf="licensePlateControl?.invalid && (licensePlateControl?.dirty || licensePlateControl?.touched)">
                <span *ngIf="licensePlateControl?.errors?.['required']">Las placas son requeridas.</span>
            </mat-error>
        </mat-form-field>
        <mat-form-field floatLabel="always" class="w-full mb-4 border-0">
            <mat-label class="text-gray text-lg">Cliente</mat-label>
            <mat-select formControlName="partnerId">
                <mat-option *ngFor="let partner of partners" [value]="partner.uid">
                    {{ partner.displayName || partner.email }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="partnerIdControl?.invalid && (partnerIdControl?.dirty || partnerIdControl?.touched)">
                <span *ngIf="partnerIdControl?.errors?.['required']">El cliente es requerido.</span>
            </mat-error>
        </mat-form-field>
        <mat-form-field floatLabel="always" class="w-full mb-4 border-0">
            <mat-label class="text-gray text-lg">Ruta</mat-label>
            <mat-select formControlName="routeId">
                <mat-option *ngFor="let route of routes" [value]="route.id">
                    {{ route.name }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="routeIdControl?.invalid && (routeIdControl?.dirty || routeIdControl?.touched)">
                <span *ngIf="routeIdControl?.errors?.['required']">La ruta es requerida.</span>
            </mat-error>
        </mat-form-field>
        <mat-form-field floatLabel="always" class="w-full mb-4 border-0">
            <mat-label class="text-gray text-lg">Entidad</mat-label>
            <mat-select formControlName="entityId">
                <mat-option *ngFor="let entity of entities" [value]="entity.id">
                    {{ entity.name }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="entityIdControl?.invalid && (entityIdControl?.dirty || entityIdControl?.touched)">
                <span *ngIf="entityIdControl?.errors?.['required']">La entidad es requerida.</span>
            </mat-error>
        </mat-form-field>
        <mat-slide-toggle formControlName="status" class="mb-4">
            Activo
        </mat-slide-toggle>
        <div>
            <button matButton type="submit" class="w-full">Guardar</button>
        </div>
    </form>
</mat-dialog-content>